"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPopper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var Popper_1 = require("../../atoms/Popper/Popper");
var Typography_1 = require("../../atoms/Typography/Typography");
var UserCard_1 = require("../UserCard/UserCard");
var UserPopper_style_1 = __importDefault(require("./UserPopper.style"));
/**
 * UserPopper molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-userpopper--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/UserPopper Source}
 */
var UserPopper = function (_a) {
    var text = _a.text, label = _a.label, className = _a.className, users = _a.users, renderCards = _a.renderCards;
    var classes = (0, UserPopper_style_1.default)();
    var _b = __read((0, react_1.useState)(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var cards = typeof renderCards === 'function' ? renderCards() : renderCards;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.anchor, className), onClick: function (event) { return setAnchorEl(function (anchorEl) { return (anchorEl ? null : event.currentTarget); }); } }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ underline: true }, { children: text })) })), (0, jsx_runtime_1.jsx)(Popper_1.Popper, __assign({ open: !!anchorEl, arrow: true, anchorEl: anchorEl, placement: 'top', offset: 2, onClickAway: function () { return setAnchorEl(null); } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.popoverContent }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: classes.header, variant: 'headline2', numberOfLines: 2 }, { children: label })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.body }, { children: cards ? cards : users === null || users === void 0 ? void 0 : users.map(function (user, index) { return (0, jsx_runtime_1.jsx)(UserCard_1.UserCard, { user: user, copyEmail: true }, (user === null || user === void 0 ? void 0 : user.id) || index); }) }))] })) }))] }));
};
exports.UserPopper = UserPopper;
